<form name="frmProfile" style="margin-top:-1.5%;">
    <div class="container panel panel-default col-md-12" style="padding-top:1% ; padding-left:0%;padding-right:0%;border-color:black;min-height:76vh;background-color: #f4f8f6;">
        <div class="activity-box" *ngIf="dataLoader"><div class="loading-spiner"><img src="assets/img/loadingVer.gif" class="load"/></div></div>
        <div class="form-group row">
            <div class="col-md-12">
                <ul class="nav nav-tabs">
                    <li [ngClass]="{active:IsTabActive(1)}" *ngIf="IsShowProfileActive"><a style="border-left-color: #460073; border-top-color: #460073; border-right-color: #460073;" (click)="SetActiveTab(1)">My Profile</a></li>
                    <li [ngClass]="{active:IsTabActive(2)}" *ngIf="IsShowMarkActive"><a style="border-left-color: #460073; border-top-color: #460073; border-right-color: #460073;" (click)="SetActiveTab(2)">My Calls</a></li>
                    <li [ngClass]="{active:IsTabActive(3)}" *ngIf="IsShowApproveActive"><a style="border-left-color: #460073; border-top-color: #460073; border-right-color: #460073;" (click)="SetActiveTab(3)">Approved Calls</a></li>
                    <li [ngClass]="{active:IsTabActive(4)}" *ngIf="IsShowReportActive"><a style="border-left-color: #460073; border-top-color: #460073; border-right-color: #460073;" (click)="SetActiveTab(4)">Generate Report</a></li>
                    <li [ngClass]="{active:IsTabActive(5)}" *ngIf="IsShowWBSEActive"><a style="border-left-color: #460073; border-top-color: #460073; border-right-color: #460073;" (click)="SetActiveTab(5)">To add WBSE</a></li>
                    <li [ngClass]="{active:IsTabActive(6)}" *ngIf="IsMyAuthcodeActive"><a style="border-left-color: #460073; border-top-color: #460073; border-right-color: #460073;" (click)="SetActiveTab(6)">My Authcodes</a></li>
                    <li [ngClass]="{active:IsTabActive(7)}" *ngIf="IsAuthcodeUpdateWBS"><a style="border-left-color: #460073; border-top-color: #460073; border-right-color: #460073;" (click)="SetActiveTab(7)">Update Authcode WBSE</a></li>

                </ul> 
                <br />
                <div class="form-group" *ngIf="IsTabActive(1)">
                    <br />
                   
                    <div class="panel panel-heading" style="padding-left:15px;padding-top: 0px;padding-bottom: 0px; background: linear-gradient(141deg, #460073 20%, #A100FF 65%); font-weight: bold; margin-top: -1.4%; color: white;">My Profile</div>
                    
                    <div class="panel-body">
                        <div class="col-lg-11" style="padding-top:1%;">
                            <div class="form-group row">
                                <div class="row" style="margin-left:0px;">
                                    <div class="col-md-6">
                                        <div class="col-md formDivCaptions">
                                            <label style="font-weight: bold">Enterprise ID:</label>&nbsp;&nbsp;&nbsp;
                                            <label>{{Eid5}}</label>
                                        </div>                                        
                                        <div class="col-md formdivcaptions" style="margin-top: 20px;">
                                            <label style="font-weight: bold">Display Name:</label>&nbsp;&nbsp;&nbsp;
                                            <label>{{staff}}</label>
                                        </div>                                    
                                    </div>

                                    <div class="col-md-6 ">
                                        <div class="col-md formDivCaptions">
                                            <label style="font-weight: bold">Country:</label>&nbsp;&nbsp;&nbsp;
                                            <label>{{count}}</label>
                                        </div>
                                        
                                        <div class="col-md formdivcaptions" style="margin-top: 20px;">
                                            <label style="font-weight: bold">WBS:</label>&nbsp;&nbsp;&nbsp;
                                            <label>{{WBS}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="IsTabActive(2)">
                    <br />
                    <div class="panel panel-heading" style="padding-left:15px;padding-top: 0px;padding-bottom: 0px; background: linear-gradient(141deg, #460073 20%, #A100FF 65%); font-weight: bold; margin-top: -2.4%; color: white;">
                        My Calls</div>
                    <div class="panel-body" style="margin-top: 30px;">
                        <div class="col-lg-12">
                            <div class="form-group row">
                                <div class="row" style="margin-left:0px;">
                                    <div class="form-group row" style="margin-top:-2%;">
                                        <div class="col-sm-2 formDivCaptions" style="margin-left:-2%;">
                                            <label><b>Call Status:</b></label>
                                        </div>
                                        <div class="col-sm-4 formDivTextBoxDropdownControls">
                                            <label class="radio-inline" style="font-size: 14px">
                                                <input type="radio" value="MarkCalls"  (click)="selectionClick($event.target.value)" name="MarkCalls" id="MarkCalls"> Mark Calls
                                            </label>
                                            <label class="radio-inline" style="font-size: 14px">
                                                <input type="radio" value="MyMarkedCalls"  (click)="selectionClick($event.target.value)" name="MarkCalls" id="MyMarkedCalls"> My Marked Calls
                                            </label>
                                        </div>    
                                    </div>    
                                </div>    
                            </div>
                        </div>
                
                
                        <div *ngIf="IsShowMarkCalls">
                            <div class="col-lg-12">
                                <div class="form-group row">
                                    <div class="row" style="margin-top:-5.5%;">
                                        <div class="col-md-6">
                                            <br /><br /><br />
                                            <div class="col-md frmProfile">
                                                <label style="font-weight: bold">Rundate:</label>&nbsp;&nbsp;
                                                <label> {{Rundate}} </label>
                                            </div>
                
                                            <div class="col-md frmProfile" style="margin-top: 20px;">
                                                <label style="font-weight: bold">Display Name:</label>&nbsp;&nbsp;
                                                <label> {{StaffName}} </label>
                                            </div>
                
                                        </div>
                                        <div class="col-sm-5">
                                            <br /><br /><br />
                                            <div class="col-md-6 formDivCaptions">
                                                <label style="font-weight: bold">Total Number of Calls:</label>
                                            </div>
                                            <div class="col-sm-6 formDivTextBoxDropdownControls">
                                                <label> {{TotalNumberOfCalls}} </label>
                                            </div>
                                            <div class="col-sm-5 formdivcaptions">
                                                <label style="font-weight: bold;margin-top: -20%;">
                                                    <span class="tooltip" style="z-index: 0;">
                                                        <img alt="" src="../../../../assets/img/info10.png" class="img-circle"
                                                            style="width: 10%; height: 10%; margin-bottom: -25%; margin-left: 79%;">
                                                        <span class="tooltiptext"
                                                            style="margin-bottom: -16px; margin-left: -50%;">Charges calculated for all
                                                            the calls.</span>
                                                    </span>Total Charges:
                                                </label>
                                            </div>
                                            <div class="col-sm-6 formDivTextBoxDropdownControls">
                                                <label> {{TotalCharges}} </label>
                                            </div>
                                            <div class="col-sm-5 formdivcaptions">
                                                <label style="font-weight: bold; margin-top: -20%;z-index: 0;">
                                                    <span class="tooltip" style="z-index: 0; ">
                                                        <img alt="" src="../../../../assets/img/info10.png" class="img-circle"
                                                            style="width: 10%; height: 10%; margin-bottom: -25%; margin-left: 79%;">
                                                        <span class="tooltiptext"
                                                            style="margin-bottom: -16px; margin-left: -50%;">Average cost is total cost
                                                            by total no of calls.</span>
                                                    </span>Average Cost:
                                                </label>
                                            </div>
                                            <div class="col-sm-6 formDivTextBoxDropdownControls">
                                                <label> {{AverageCost}} </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" id="divMarkCallDetails" style="overflow:scroll;display:none;">
                                    <table id="MarkCallDetails" class="table table-bordered" border="1"
                                        style="width:100%;font-size:13px;margin-left:2%;">
                                        <thead>
                                            <tr
                                                style="background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                                                <th style="display:none">S.No</th>
                                                <th><label style="width:30px; text-align :center;"><input type='checkbox'
                                                            [(ngModel)]="selectedAll" (click)="checkAll($event.target.checked,'MarkCalls')" id="selectedAll"
                                                            name="selectedAll" /></label> </th>
                                                <th style="text-align: center;color:whitesmoke;">Call Status</th>
                                                <th style="text-align: center; min-width: 90px;color:whitesmoke;">Date</th>
                                                <th style="text-align: center;color:whitesmoke;">Time</th>
                                                <th style="text-align: center;color:whitesmoke;">Extension</th>
                                                <th style="text-align: center;color:whitesmoke;">Called Number</th>
                                                <th style="text-align: center;color:whitesmoke;">Duration</th>
                                                <th style="text-align: center;color:whitesmoke;">Cost</th>
                                                <th style="text-align: center;color:whitesmoke;">WBS Element</th>
                                                <th style="text-align: center;color:whitesmoke;">Approver</th>
                                                <th style="text-align: center;color:whitesmoke;">Approval Status</th>
                                                <th style="text-align: center;color:whitesmoke;">Remarks</th>
                                                <!--<th style="text-align: center;">Active</th>-->
                                            </tr>
                                        </thead>
                                        <tbody *ngFor="let markCall of successfulData.markCalls">
                                            <tr>
                                                <td style="display:none">{{markCall.cdrId}}</td>
                                                <td><label style="width:30px; text-align :center;"><input type='checkbox'
                                                    [(ngModel)]="markCall.checked" id="check" name="check" [checked]="markCall.checked"
                                                    (click)="PreviewClick(markCall,'MarkCall')" /></label> </td>
                                                <!-- <td><label style="width:30px; text-align :center;"><input type='checkbox' [(ngModel)]="markCall.checked" id="check" name="check" (click)="OnClick()" /></label> </td> -->
                                                <td>
                                                    {{markCall.callStatus}}
                                                </td>
                                                <td>
                                                    {{markCall.Date}}
                                                </td>
                                                <td>
                                                    {{markCall.Time}}
                                                </td>
                                                <td>
                                                    {{markCall.callingPartyNumber}}
                                                </td>
                                                <td>
                                                    {{markCall.originalCalledPartyNumber}}
                                                </td>
                                                <td>
                                                    {{markCall.cduration}}
                                                </td>
                                                <td>
                                                    {{markCall.callCost}}
                                                </td>
                                                <td>
                                                    {{markCall.wbs}}
                                                </td>
                                                <!--<td>
                                                            {{markCall.costCenter}}
                                                        </td>-->
                                                <td>
                                                    {{markCall.emp_name}}
                                                </td>
                                                <td>
                                                    {{markCall.approvalStatus}}
                                                </td>
                                                <td>
                                                    {{markCall.remarks}}
                                                </td>
                                                <!--<td>{{markCall.Active}}</td>-->
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colspan="11" style="text-align: center;">
                                                    <!-- pager -->
                                                    <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                                        <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                            <a><i (click)="setPage(1)" class="icon-fast-backward"></i>
                                                            </a>
                                                        </li>
                                                        <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                            <a><i (click)="setPage(pager.currentPage - 1)" class="icon-step-backward"></i></a>
                                                        </li>
                                                        <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                                            <a (click)="setPage(page)">{{page}}</a>
                                                        </li>
                                                        <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                                            <a (click)="setPage(pager.startPage + 5)">...</a>
                                                        </li>
                                                        <li *ngIf="(pager.totalPages - pager.startPage) > 5" >
                                                            <a (click)="setPage(pager.totalPages)">{{pager.totalPages}}</a>
                                                        </li>
                                                        
                                                        <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                            <a><i (click)="setPage(pager.currentPage + 1)" class="icon-step-forward"></i></a>
                                                        </li>
                                                        <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                            <a><i (click)="setPage(pager.totalPages)" class="icon-fast-forward"></i></a>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                
                                </div>
                
                
                                <div class="row" id="divWBSMarkCallDetails" style="display:none;">
                                    <table id="WBSMarkCallDetails" class="table table-bordered table-responsive" border="1"
                                        style="width:100%;font-size:13px;margin-left:2%; height:40px;">
                                        <thead>
                                            <tr
                                                style="background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                                                <th style="display:none">S.No</th>
                                                <!--<th> </th>-->
                                                <!-- <th><label style="width:30px; text-align :center;"><input type='checkbox'
                                                            [(ngModel)]="selectedAll" (click)="checkAll('WBSMarkCalls')"
                                                            id="selectedAll" name="selectedAll" /></label> </th> -->
                                                <th></th>
                                                <!--  <th style="text-align: center;">Call Status</th>-->
                                                <th style="text-align: center; min-width: 90px;color:whitesmoke;">Date</th>
                                                <th style="text-align: center;color:whitesmoke;">Time</th>
                                                <th style="text-align: center;color:whitesmoke;">Extension</th>
                                                <th style="text-align: center;color:whitesmoke;">Called Number</th>
                                                <th style="text-align: center;color:whitesmoke;">Duration</th>
                                                <th style="text-align: center;color:whitesmoke;">Cost</th>
                                                <th style="text-align: center;color:whitesmoke;">WBS Element</th>
                
                                                <!--<th style="text-align: center;">Remarks</th>-->
                                                <!--<th style="text-align: center;">Active</th>-->
                                            </tr>
                                        </thead>
                                        <tbody *ngFor="let WBSmarkCall of successfulData.WBSmarkCallsData;">
                                            <tr *ngIf="WBSmarkCall.cdrId != successfulData.selected.cdrId">
                                                <td style="display:none">{{WBSmarkCall.cdrId}}</td>
                
                                                <!--<img src="/img/Edit-icon.png" title="Edit" ng-click="EditWBSMarkCall(WBSmarkCall)" />-->
                                                <!-- <td><label style="width:30px; text-align :center;"><input type='checkbox'
                                                            [checked]="WBSmarkCall.checked" id="check"
                                                            (click)="PreviewClick(WBSmarkCall,'WBSmarkCallChecked')" /></label> </td> -->
                
                                                <!--<td>
                                                            {{WBSmarkCall.callStatus}}
                                                        </td>-->
                                            <td><img src="../../../../assets/img/Edit-icon.png" title="Edit" (click)="EditWBSCode(WBSmarkCall)" />
                                                        </td>
                                                <td>
                                                    {{WBSmarkCall.Date}}
                                                </td>
                                                <td>
                                                    {{WBSmarkCall.Time}}
                                                </td>
                                                <td>
                                                    {{WBSmarkCall.callingPartyNumber}}
                                                </td>
                                                <td>
                                                    {{WBSmarkCall.originalCalledPartyNumber}}
                                                </td>
                                                <td>
                                                    {{WBSmarkCall.cduration}}
                                                </td>
                                                <td>
                                                    {{WBSmarkCall.callCost}}
                                                </td>
                                                <!-- <td>                                                    
                                                    <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;"
                                                        class="col-md-1">
                                                        <span>*</span>
                                                    </div>
                                                    <input type="text" class="form-control" [(ngModel)]="WBSmarkCall.wbs" 
                                                        id="grdMarkWBS" name="grdMarkWBS" disabled />
                                                </td> -->
                                                <td>
                                                    {{WBSmarkCall.wbs}}
                                                </td>
                                                <!--<td>
                                                            {{markCall.costCenter}}
                                                        </td>-->
                                                <!--<td>
                                                            {{WBSmarkCall.remarks}}
                                                        </td>-->
                                                <!--<td>{{markCall.Active}}</td>-->
                                            </tr>
                                            <tr *ngIf="WBSmarkCall.cdrId === successfulData.selected.cdrId">
                                                <td style="width:75px;">
                                                    <img src="../../../../assets/img/Add.png" (click)="UpdateWBSCode(WBSmarkCall)" title="Update" />
                                                    <img src="../../../../assets/img/Cancel.jpg" (click)="resetWBS()" title="Cancel" />
                                                </td>
                                                <td style="display:none;">{{successfulData.selected.cdrId}}</td>
                                                <td>
                                                    <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                        <span></span>
                                                    </div>
                                                    <input  type="text" class="form-control" maxlength="25" [(ngModel)]="successfulData.selected.Date" readonly="readonly" [disabled]="true" id="grdDate" name="grdDate" />
                                                </td>
                                                <td>
                                                    <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                        <span></span>
                                                    </div>
                                                    <input type="text" class="form-control" maxlength="25" [(ngModel)]="successfulData.selected.Time" readonly="readonly" [disabled]="true" id="grdTime" name="grdTime" />
                                                </td>
                                                <td>
                                                    <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                        <span></span>
                                                    </div>
                                                    <input type="text" class="form-control" maxlength="25" [(ngModel)]="successfulData.selected.callingPartyNumber"  readonly="readonly" [disabled]="true" id="grdcallingPartyNumber" name="grdcallingPartyNumber" />
                                                </td>
                                                <td>
                                                    <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                        <span></span>
                                                    </div>
                                                    <input type="text" class="form-control" maxlength="25" [(ngModel)]="successfulData.selected.originalCalledPartyNumber" readonly="readonly" [disabled]="true" id="grdoriginalCalledPartyNumber" name="grdoriginalCalledPartyNumber" />
                                                </td>
                                                <td>
                                                    <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                        <span></span>
                                                    </div>
                                                    <input type="text" class="form-control" maxlength="25" [(ngModel)]="successfulData.selected.cduration" readonly="readonly" [disabled]="true" id="grdcduration" name="grdcduration" />
                                                </td>
                                                <td>
                                                    <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                        <span></span>
                                                    </div>
                                                    <input type="text" class="form-control" maxlength="25" [(ngModel)]="successfulData.selected.callCost" readonly="readonly" [disabled]="true" id="grdcallCost" name="grdcallCost" />
                                                </td>
                                                <td>
                                                    <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                        <span>*</span>
                                                    </div>
                                                    <!-- <input type="text" class="form-control" maxlength="8" [(ngModel)]="successfulData.selected.wbs" id="grdwbs" name="grdwbs" /> -->
                                                    <select [(ngModel)]="successfulData.selected.wbs" id="grdwbs" name="grdwbs" class="form-control">
                                                        <option value="">&lt;--Select--&gt;</option>
                                                        <option *ngFor="let AssignBSEData of AssignBSEDatas">{{AssignBSEData.ChargeCode}}</option>        
                                                    </select>
                                                </td>                                                
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colspan="11" style="text-align: center;">
                                                    <!-- pager -->
                                                    <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                                        <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                            <a><i (click)="setPageone(1)" class="icon-fast-backward"></i>
                                                            </a>
                                                        </li>
                                                        <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                            <a><i (click)="setPageone(pager.currentPage - 1)" class="icon-step-backward"></i></a>
                                                        </li>
                                                        <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                                            <a (click)="setPageone(page)">{{page}}</a>
                                                        </li>
                                                        <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                                            <a (click)="setPageone(pager.startPage + 5)">...</a>
                                                        </li>
                                                        <li *ngIf="(pager.totalPages - pager.startPage) > 5" >
                                                            <a (click)="setPageone(pager.totalPages)">{{pager.totalPages}}</a>
                                                        </li>
                                                        
                                                        <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                            <a><i (click)="setPageone(pager.currentPage + 1)" class="icon-step-forward"></i></a>
                                                        </li>
                                                        <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                            <a><i (click)="setPageone(pager.totalPages)" class="icon-fast-forward"></i></a>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <div class="col-sm-3 formdivcaptions" style="display: none;">
                                    <div id="WBSMarkCallSubmit" style="display:none;margin-top:4%;">
                                        <div class="col-sm-6">
                                            <button type="submit" id="btneSelectWBSE" class="btn btn-default btn-group-sm Button1"
                                                (click)="SelectWBSEData()">Select WBSE</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </div>
                                        <div class="col-sm-2">
                                            <button type="submit" id="btnWBSMarkCall" class="btn btn-default btn-group-sm Button1"
                                                (click)="WBSMarkCallSubmitData()"> Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                
                        </div>
                        <div *ngIf="IsShowMyMarkCalls">
                            <div class="col-lg-12">
                                <br /> <br />
                                <div class="form-group row">
                                    <div class="row" style="margin-top:-6%;">
                                        <div class="col-sm-6 ">
                                            <br />
                                            <div class="col-sm-4 frmProfile">
                                                <label style="font-weight: bold">Rundate:</label>
                                            </div>
                                            <div class="col-sm-6 formDivTextBoxDropdownControls">
                                                <label> {{Rundate}} </label>
                                            </div>
                                            <div class="col-sm-4 frmProfile">
                                                <label style="font-weight: bold">Display Name:</label>
                                            </div>
                                            <div class="col-sm-6 formDivTextBoxDropdownControls">
                                                <label> {{StaffName}} </label>
                                            </div>
                                            <div class="col-sm-4 frmProfile">
                                                <label style="font-weight: bold">Employee Number:</label>
                                            </div>
                                            <div class="col-sm-6 formDivTextBoxDropdownControls">
                                                <label> {{EmployeeNO}} </label>
                                            </div>
                                        </div>
                
                                        <div class="col-sm-6 " style=" margin-left: -50px">
                                            <table id="tblMyMarkCallsDetails" class="table table-bordered"
                                                style="width: 100%; font-size: 13px; border-width: 1px">
                                                <tr style="background-color: white; height: 25px; border-width: 0px;">
                                                    <th style="text-align: center; width: 150px; color: black; border-width: 0px"></th>
                                                    <th style="text-align: center; width: 10px; color: black; border-width: 0px"></th>
                                                    <th style="text-align: center; width: 150px; color: black; border-width: 0px">Total
                                                        No. Of Calls</th>
                                                    <th style="text-align: center; width: 130px; color: black; border-width: 0px">Call
                                                        Cost</th>
                                                </tr>
                                                <tbody *ngFor="let detail of myMarkCall.myMarkCallsDetails">
                                                    <tr style="border-width: 0px">
                                                        <td style="font-weight: bold; border-width: 0px; text-align: center;">
                                                            {{detail.callStatus}}</td>
                                                        <td style="border-width: 0px; text-align: center;"></td>
                                                        <td style="border-width: 0px; text-align: center;">
                                                            {{detail.TotalNoOfCalls}}
                                                        </td>
                                                        <td style="border-width: 0px; text-align: center;">
                                                            {{detail.CallCost}}
                                                        </td>
                
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" id="divMyMarkCallDetails" style="overflow:scroll;">
                                    <table id="MarkCallDetails" class="table table-bordered" border="1"
                                        style="width:100%;font-size:13px;margin-left:2%;">
                                        <thead>
                                            <tr
                                                style="background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                                                <th style="display:none">S.No</th>
                                                <th style="text-align: center;color:whitesmoke;"></th>
                                                <th style="text-align: center;color:whitesmoke; min-width: 90px;">Date</th>
                                                <th style="text-align: center;color:whitesmoke;">Time</th>
                                                <th style="text-align: center;color:whitesmoke;">Extension</th>
                                                <th style="text-align: center;color:whitesmoke;">Called Number</th>
                                                <th style="text-align: center;color:whitesmoke;">Duration</th>
                                                <th style="text-align: center;color:whitesmoke;">Cost</th>
                                                <th style="text-align: center;color:whitesmoke;">WBS Element</th>
                                                <th style="text-align: center;color:whitesmoke;">Call Status</th>
                                                <th style="text-align: center;color:whitesmoke;">Approver</th>
                                                <th style="text-align: center;color:whitesmoke;">Approval Status</th>
                                                <th style="text-align: center;color:whitesmoke;">Remarks</th>
                                                <!--<th style="text-align: center;">Active</th>-->
                                            </tr>
                                        </thead>
                                        <tbody *ngFor="let myMarkCall of successfulData.myMarkCalls">
                                            <tr>
                                                <td style="display:none">{{myMarkCall.Sno}}</td>
                                                <td>
                                                    <img src="../../../../assets/img/Edit-icon.png" title="Edit"
                                                        (click)="PreviewClick(myMarkCall,'MyMarkCall')" />
                                                </td>
                                                <td>
                                                    {{myMarkCall.Date}}
                                                </td>
                                                <td>
                                                    {{myMarkCall.Time}}
                                                </td>
                                                <td>
                                                    {{myMarkCall.callingPartyNumber}}
                                                </td>
                                                <td>
                                                    {{myMarkCall.originalCalledPartyNumber}}
                                                </td>
                                                <td>
                                                    {{myMarkCall.cduration}}
                                                </td>
                                                <td>
                                                    {{myMarkCall.callCost}}
                                                </td>
                                                <td>
                                                    {{myMarkCall.wbs}}
                                                </td>
                                                <td>
                                                    {{myMarkCall.callStatus}}
                                                </td>
                                                <td>
                                                    {{myMarkCall.approverEid}}
                                                </td>
                                                <td>
                                                    {{myMarkCall.approvalStatus}}
                                                </td>
                                                <td>
                                                    {{myMarkCall.remarks}}
                                                </td>
                    
                                            </tr>
                                        </tbody>
                                       <tfoot>
                                        <tr>
                                            <td colspan="11" style="text-align: center;">
                                                <!-- pager -->
                                                <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                        <a><i (click)="setPagetwo" class="icon-fast-backward"></i>
                                                        </a>
                                                    </li>
                                                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                        <a><i (click)="setPagetwo(pager.currentPage - 1)" class="icon-step-backward"></i></a>
                                                    </li>
                                                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                                        <a (click)="setPagetwo(page)">{{page}}</a>
                                                    </li>
                                                    <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                                        <a (click)="setPagetwo(pager.startPage + 5)">...</a>
                                                    </li>
                                                    <li *ngIf="(pager.totalPages - pager.startPage) > 5" >
                                                        <a (click)="setPagetwo(pager.totalPages)">{{pager.totalPages}}</a>
                                                    </li>
                                                    
                                                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                        <a><i (click)="setPagetwo(pager.currentPage + 1)" class="icon-step-forward"></i></a>
                                                    </li>
                                                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                        <a><i (click)="setPagetwo(pager.totalPages)" class="icon-fast-forward"></i></a>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                       </tfoot>
                                    </table>
                                    <br />
                                    <div align="center">
                                        <button type="submit" id="btnPreviewMyMarkedCalls" class="btn btn-default btn-group-sm Button1"
                                            (click)="PreviewReport('ReportMarkedCallDetails')"><span class=""
                                                aria-hidden="true"></span>Export to Excel</button>
                                    </div>
                                </div>
                            </div>

                           
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="IsTabActive(3)">
                    <br />
                    <div class="panel panel-heading" style="padding-left:15px;padding-top: 0px;padding-bottom: 0px; background: linear-gradient(141deg, #460073 20%, #A100FF 65%); font-weight: bold; margin-top: -2.4%; color: white;">Approved Calls</div>
                    <div class="panel-body" style="margin-top: 30px;">
                        <div class="col-lg-12">
                            <div class="form-group row">
                                <div class="row" style="margin-left:0px;">
                                    <div class="form-group row" style="margin-top:-2%;">
                                        <div class="col-sm-2 formDivCaptions" style="margin-left:-2%;">
                                            <label><b>Approve Status:</b></label>
                                        </div>
                                        <div class="col-sm-4 formDivTextBoxDropdownControls">
                                            <label class="radio-inline" style="font-size: 14px">
                                                <input type="radio" value="ApproveCalls" [(ngModel)]="approveOption" (click)="selectionApproveClick($event.target.value)" name="ApproveCalls" id="ApproveCalls"> Approve Calls
                                            </label>
                                            <label class="radio-inline" style="font-size: 14px">
                                                <input type="radio" value="MyApprovedCalls" [(ngModel)]="approveOption" (click)="selectionApproveClick($event.target.value)" name="ApproveCalls" id="MyApprovedCalls"> My Approved Calls
                                            </label>
                                        </div>    
                                    </div>    
                                </div>    
                            </div>
                        </div> 
                        <div *ngIf="IsShowApproveCalls">
                            <div class="col-lg-14" style="padding-top:1%;">
                                <div class="form-group row">
                                    <div class="row" style="margin-left:0px;">
                                        <div class="col-sm-8 ">
                                            <br />
                                            <div style="margin-top:-7%;">
                                                <br />
                                                <div class="col-sm-4 frmProfile">
                                                    <label style="font-weight: bold"> Enter WBS Element :</label>
                                                </div>
                                                <div class="col-sm-6 formDivTextBoxDropdownControls">
                                                    <input type="text" style="width:200px" class="form-control" id="txtWBS" name="txtWBS" [(ngModel)]="ApproveCallsOptionWBS" />
                                                </div>
                                                <br /><br />
                                                <div class="col-sm-4 frmProfile">
                                                    <label style="font-weight: bold"> Select Enterprise ID:</label>
                                                </div>
                                                <div class="col-sm-6 formDivTextBoxDropdownControls">
                                                    <select class="form-control" id="dlstEID" name="dlstEID" [(ngModel)]="dlstEID" style="width:200px">
                                                        <option value="">&lt;--Select--&gt;</option>
                                                        <option *ngFor="let EID of EIDList" value="{{EID.eId}}">{{EID.eId}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 " style="margin-top: -155px; margin-left: 500px">
                                        <br/><br/><br/><br/>
                                        <table id="tblApproveCallsDetails" class="table table-bordered" style="width: 100%; font-size: 13px; border-width: 1px">
                                            <thead>
                                            <tr style="background-color: white; height: 25px; border-width: 0px;">
                                                <th style="text-align: center; width: 150px; color: black; border-width: 0px"></th>
                                                <th style="text-align: center; width: 10px; color: black; border-width: 0px"></th>
                                                <th style="text-align: center; width: 150px; color:  black; border-width: 0px">Total Calls</th>
                                                <th style="text-align: center; width: 130px; color: black; border-width: 0px">Total Cost</th>
                                            </tr>
                                           </thead>
                                           <tbody *ngFor="let detail of approveCall.approveCallsDetailedDetails">
                                            <tr style="border-width: 0px">
                                                <td style="font-weight: bold; border-width: 0px; text-align: center;">{{detail.CallStatus}}</td>
                                                <td style="border-width: 0px; text-align: center;"></td>
                                                <td style="border-width: 0px; text-align: center;">
                                                    {{detail.TotalNoOfCalls}}
                                                </td>
                                                <td style="border-width: 0px; text-align: center;">
                                                    {{detail.CallCost}}
                                                </td>

                                            </tr>
                                           </tbody>
                                        </table>
                                    </div>    
                                </div>
                            </div>
                            <br />
                            <div align="center">
                                <button type="submit" style="margin-top: -62px; margin-left: -480px; " id="btnApproveCallsOptionWBSE" class="btn btn-default btn-group-sm Button1" (click)="ShowData('SearchApproveDetails')"><span class="" aria-hidden="true"></span>Search</button>
                            </div>

                            <div class="row" id="divApproveCallDetails" style="overflow:scroll;">
                                <table id="approveCallDetails" class="table table-bordered" border="1" style="width:100%;font-size:13px;">
                                <thead>
                                    <tr style="background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                                        <th style="display:none">S.No</th>
                                        <th><label style="width:30px; text-align :center;"><input type='checkbox' [(ngModel)]="selectedAll" (click)="checkAll($event.target.checked,'ApproveCalls')" id="selectedAll" name="selectedAll"/></label> </th>
                                        <th style="text-align: center;color:whitesmoke;">Approval Status</th>
                                        <th style="text-align: center; min-width: 90px;color:whitesmoke;">Date</th>
                                        <th style="text-align: center;color:whitesmoke;">Time</th>
                                        <th style="text-align: center;color:whitesmoke;">Duration</th>
                                        <th style="text-align: center;color:whitesmoke;">Cost</th>
                                        <th style="text-align: center;color:whitesmoke;">Extension</th>
                                        <th style="text-align: center;color:whitesmoke;">Called Number</th>
                                        <th style="text-align: center;color:whitesmoke;">Call Details</th>
                                        <th style="text-align: center;color:whitesmoke;">Reason</th>
                                        <th style="text-align: center;color:whitesmoke;">WBS Element</th>
                                        <th style="text-align: center;color:whitesmoke;">Enterprise Id</th>
                                        <th style="text-align: center;color:whitesmoke;">Approval Date</th>

                                    </tr>
                                </thead>
                                <tbody *ngFor="let data of successfulData.approveCallsDetails">
                                    <tr>
                                        <td style="display:none">{{data.cdrId}}</td>

                                        <td>
                                            <label style="width:30px; text-align :center;"><input type='checkbox' id="check" name="check" [(ngModel)]=" data.checked" (click)="PreviewClick(data,'ApproveCalls')" /></label>
                                        </td>

                                        <td>
                                            {{data.approvalStatus}}
                                        </td>
                                        <td>
                                            {{data.Date | date: 'yyyy-MM-dd'}}
                                        </td>
                                        <td>
                                            {{data.Time}}
                                        </td>
                                        <td>
                                            {{data.cduration}}
                                        </td>
                                        <td>
                                            {{data.callCost}}
                                        </td>
                                        <td>
                                            {{data.callingPartyNumber}}
                                        </td>
                                        <td>
                                            {{data.OriginalCalledPartyNumber}}
                                        </td>
                                        <td>
                                            {{data.callStatus}}
                                        </td>
                                        <td>
                                            {{data.remarks}}
                                        </td>
                                        <td>
                                            {{data.wbs}}
                                        </td>
                                        <td>
                                            {{data.eId}}
                                        </td>
                                        <td>
                                            {{data.approvalDate| date: 'yyyy-MM-dd'}}
                                        </td>

                                    </tr>
                                </tbody>
                                <tfoot>
                                    <td colspan="11" style="text-align: center;">
                                        <!-- pager -->
                                        <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                            <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                <a><i (click)="setPageappcalls" class="icon-fast-backward"></i>
                                                </a>
                                            </li>
                                            <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                <a><i (click)="setPageappcalls(pager.currentPage - 1)" class="icon-step-backward"></i></a>
                                            </li>
                                            <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                                <a (click)="setPageappcalls(page)" style="z-index: 0;">{{page}}</a>
                                            </li>
                                            <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                                <a (click)="setPageappcalls(pager.startPage + 5)">...</a>
                                            </li>
                                            <li *ngIf="(pager.totalPages - pager.startPage) > 5" >
                                                <a (click)="setPageappcalls(pager.totalPages)">{{pager.totalPages}}</a>
                                            </li>
                                            
                                            <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                <a><i (click)="setPageappcalls(pager.currentPage + 1)" class="icon-step-forward"></i></a>
                                            </li>
                                            <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                <a><i (click)="setPageappcalls(pager.totalPages)" class="icon-fast-forward"></i></a>
                                            </li>
                                        </ul>
                                    </td>
                                </tfoot>    
                                </table>
                            </div>
                        </div>
                        
                        <div *ngIf="IsShowMyApprovedCalls">
                            <div class="col-lg-12">
                                <br /><br />
                                <div style="margin-left:8px;margin-top:-5%;">
                                    <div class="col-sm-4 frmProfile">
                                        <label style="font-weight: bold"> Enter WBS Element :</label>
                                    </div>
                                    <div class="col-sm-6" style="margin-bottom:3%;height:28px;">
                                        <input type="text" style="width:200px" class="form-control" id="txtWBS1" name="txtWBS1" [(ngModel)]="ApproveCallsOptionWBS1" />
                                    </div>
                                    <br/>
                                    <div class="col-sm-4 frmProfile">
                                        <label style="font-weight: bold"> Select Enterprise ID:</label>
                                    </div>
                                    <div class="col-sm-6 formDivTextBoxDropdownControls">
                                        <select class="form-control" id="dlstEID1" name="dlstEID1" [(ngModel)]="dlstEID1" style="width:200px">
                                            <option value="">&lt;--Select--&gt;</option>
                                            <option *ngFor="let EID of EIDList" value="{{EID.eId}}">{{EID.eId}}</option>
                                        </select>
                                        
                                    </div>
                                    <div align="center" style="margin-left: -40%;">
                                        <button type="submit" style="margin-top: -55px; margin-left: 14% " id="btnApproveCallsOptionWBSE" class="btn btn-default btn-group-sm Button1" (click)="ShowData('SearchMyApproveDetails')"><span class="" aria-hidden="true"></span>Search</button>
                                    </div>
                                    
                                </div>
                               
                            
                            <div class="row" id="divMyApproveCallDetails" style="overflow:scroll;">
                                <table id="myApproveCallDetails" class="table table-bordered" border="1" style="width:100%;font-size:13px;">
                                <thead>
                                    <tr style="background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                                        <th style="display:none">S.No</th>
                                        <th style="text-align: center;"></th>
                                        <th style="text-align: center; min-width: 90px;color:whitesmoke;">Date</th>
                                        <th style="text-align: center;color:whitesmoke;">Time</th>
                                        <th style="text-align: center;color:whitesmoke;">Extension</th>
                                        <th style="text-align: center;color:whitesmoke;">Called Number</th>
                                        <th style="text-align: center;color:whitesmoke;">Duration</th>
                                        <th style="text-align: center;color:whitesmoke;">Cost</th>
                                        <th style="text-align: center;color:whitesmoke;">WBS Element</th>
                                        <th style="text-align: center;color:whitesmoke;">Call Status</th>
                                        <th style="text-align: center;color:whitesmoke;">Enterprise ID</th>
                                        <th style="text-align: center;color:whitesmoke;">Approval Status</th>
                                        <th style="text-align: center;color:whitesmoke;">Remarks</th>
                                        <!--<th style="text-align: center;">Active</th>-->
                                    </tr>
                                </thead>
                                <tbody *ngFor="let data of successfulData.myApproveCallsDetails">
                                    <tr>
                                        <td style="display:none">{{data.cdrId}}</td>
                                        <td>
                                            <img src="../../../../assets/img/Edit-icon.png" title="Edit" (click)="PreviewClick(data,'MyApproveCall')" />
                                        </td>
                                        <td>
                                            {{data.Date}}
                                        </td>
                                        <td>
                                            {{data.Time}}
                                        </td>
                                        <td>
                                            {{data.callingPartyNumber}}
                                        </td>
                                        <td>
                                            {{data.originalCalledPartyNumber}}
                                        </td>
                                        <td>
                                            {{data.cduration}}
                                        </td>
                                        <td>
                                            {{data.callCost}}
                                        </td>
                                        <td>
                                            {{data.wbs}}
                                        </td>
                                        <td>
                                            {{data.callStatus}}
                                        </td>
                                        <td>
                                            {{data.eId}}
                                        </td>
                                        <td>
                                            {{data.approvalStatus}}
                                        </td>
                                        <td>
                                            {{data.remarks}}
                                        </td>
                                        <!--<td>{{data.Active}}</td>-->
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="11" style="text-align: center;">
                                            <!-- pager -->
                                            <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                                <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                    <a><i (click)="setPagemyappcalls" class="icon-fast-backward"></i>
                                                    </a>
                                                </li>
                                                <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                    <a><i (click)="setPagemyappcalls(pager.currentPage - 1)" class="icon-step-backward"></i></a>
                                                </li>
                                                <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                                    <a (click)="setPagemyappcalls(page)" style="z-index: 0;">{{page}}</a>
                                                </li>
                                                <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                                    <a (click)="setPagemyappcalls(pager.startPage + 5)">...</a>
                                                </li>
                                                <li *ngIf="(pager.totalPages - pager.startPage) > 5" >
                                                    <a (click)="setPagemyappcalls(pager.totalPages)">{{pager.totalPages}}</a>
                                                </li>
                                                
                                                <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                    <a><i (click)="setPagemyappcalls(pager.currentPage + 1)" class="icon-step-forward"></i></a>
                                                </li>
                                                <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                    <a><i (click)="setPagemyappcalls(pager.totalPages)" class="icon-fast-forward"></i></a>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tfoot>    
                                </table>
                                <br />
                           
                                <div align="center">
                                    <button type="submit" id="btnPreviewReport" class="btn btn-default btn-group-sm Button1" (click)="PreviewReport('ReportApprovedCallDetails')"><span class="" aria-hidden="true"></span>Export to Excel</button>
                                </div>
                            </div>
                        </div>
                           
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="IsTabActive(4)">
                    <div>
                        <div class="col-lg-12">
                            <div class="col-sm-4">
                                <div class="col-sm-6 frmProfile">
                                    <label style="font-weight: bold"> Period From</label>
                                </div>
                                <div class="col-sm-6" style="margin-bottom:3%;height:28px;">
                                    <!--  <input type="text"  class="form-control datepicker" ng-model="Reports.txtperiodfrom" ng-change="Encryptfunction(Reports.txtperiodfrom)" placeholder="yyyy-MM-dd" />-->
                                     <!-- <input type="text" class="form-control datepicker" [(ngModel)]="txtperiodfrom" id="txtperiodfrom" placeholder="yyyy-MM-dd" />  -->
                                    <!-- <div class="input-group">
                                        <input class="form-control" placeholder="yyyy-mm-dd"
                                               name="dp" [(ngModel)]="txtperiodfrom" ngbDatepicker #d="ngbDatepicker">
                                       
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
                                        </div>
                                    </div> -->
                                    <!-- <input type="text" placeholder="yyyy-MM-dd" class="form-control" [(ngModel)]="txtperiodfrom" id="txtperiodfrom" name="txtperiodfrom" autocomplete="off" bsDatepicker> -->
                                    <input type="text" matInput name="txtperiodfrom" class="form-control form-control-sm" id="txtperiodfrom" [(ngModel)]="txtperiodfrom" placeholder="yyyy-MM-dd" [matDatepicker]="PeriodFrom" (focus)="showPicker()" autocomplete="off"/>
                                    <mat-datepicker #PeriodFrom></mat-datepicker> 
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="col-sm-4 frmProfile">
                                    <label style="font-weight: bold"> Period To</label>
                                </div>
                                <div class="col-sm-6" style="margin-bottom:3%;height:28px;">
                                    <!-- <input type="text" class="form-control datepicker" [(ngModel)]="txtperiodTo" id="txtperiodTo" placeholder="yyyy-MM-dd" /> -->
                                    <!-- <input type="text" placeholder="yyyy-MM-dd" class="form-control" [(ngModel)]="txtperiodTo" id="txtperiodTo" name="txtperiodTo" autocomplete="off"  bsDatepicker> -->
                                    <input type="text" matInput name="txtperiodTo" class="form-control form-control-sm" id="txtperiodTo" [(ngModel)]="txtperiodTo" placeholder="yyyy-MM-dd" [matDatepicker]="PeriodTo" (focus)="showPickerTo()" autocomplete="off"/>
                                    <mat-datepicker #PeriodTo></mat-datepicker> 
                                </div>
                            </div>
                            <div align="left">
                                <button type="submit" id="btnGenerateReport" class="btn btn-default btn-group-sm Button1" (click)="ShowData('GenerateReportDetails','search')"><span class="" aria-hidden="true"></span>Search</button>
                                <button type="button" style="margin-left:20px;" id="btnExcelExport" class="btn btn-default btn-group-sm" (click)="ShowData('GenerateReportDetails','export')"><span class="glyphicon glyphicon-export" aria-hidden="true"></span> Export to Excel</button>
                            </div>
                            <div *ngIf="showReport" style="margin-top: 5rem;" >
                                <table class="table table-bordered border-dark">
                                    <thead style="background-color: #a11bc6; border:1.2px solid rgb(52, 51, 51)">
                                      <tr style="border:1.5px solid rgb(52, 51, 51)">
                                        <th scope="col" style="border:1.2px solid rgb(52, 51, 51)">AuthCode</th>
                                        <th scope="col"style="border:1.2px solid rgb(52, 51, 51)">Ext No</th>
                                        <th scope="col" style="border:1.2px solid rgb(52, 51, 51)">Date</th>
                                        <th scope="col" style="border:1.2px solid rgb(52, 51, 51)">Time</th>
                                        <th scope="col" style="border:1.2px solid rgb(52, 51, 51)">Called Number</th>
                                        <th scope="col" style="border:1.2px solid rgb(52, 51, 51)">Destination</th>
                                        <th scope="col" style="border:1.2px solid rgb(52, 51, 51)">CallType</th>
                                        <th scope="col" style="border:1.2px solid rgb(52, 51, 51)">Duration</th>
                                        <th scope="col" style="border:1.2px solid rgb(52, 51, 51)">Cost</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr *ngFor="let row of generateReport" style="border:1.5px solid rgb(52, 51, 51)">
                                        <td style="border:1.2px solid rgb(52, 51, 51)">{{row.AuthCode}}</td>
                                        <td style="border:1.2px solid  rgb(52, 51, 51)">{{row['Ext No']}}</td>
                                        <td style="border: 1.2px solid rgb(52, 51, 51)">{{row.Date}}</td>
                                        <td style="border:1.2px solid rgb(52, 51, 51)">{{row.Time}}</td>
                                        <td style="border:1.2px solid rgb(52, 51, 51)">{{row['Called Number']}}</td>
                                        <td style="border:1.2px solid rgb(52, 51, 51)">{{row.Destination}}</td>
                                        <td style="border:1.2px solid rgb(52, 51, 51)">{{row.CallType}}</td>
                                        <td style="border:1.2px solid rgb(52, 51, 51)">{{row.Duration}}</td>
                                        <td style="border:1.2px solid rgb(52, 51, 51)">{{row.Cost}}</td>
                                        
                                      </tr>
                                    </tbody>
                                  </table>
                            </div>
                        </div>
                       
                        <div class="row" id="divGenerateReport" style="display: none;">
                            <br />
                            <div style="overflow-y:scroll;">
                                <table id="GenerateReportDetails" class="table table-bordered" border="1" style="overflow-y:scroll;font-size:13px;width:100%;box-sizing: border-box;">
                                <thead>
                                    <tr style="background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); ">
                                        <!--<th>cdrId</th>-->
                                        <th style="text-align: center;color: whitesmoke;">Calling Party Number</th>
                                        <th style="text-align: center;color: whitesmoke;">Original Called Party Number</th>
                                        <!--<th style="text-align: center;">Date Time Disconnect</th>-->
                                        <th style="text-align: center;color: whitesmoke;">Duration</th>
                                        <th style="text-align: center;color: whitesmoke;">Auth Code Description</th>
                                        <th style="text-align: center;color: whitesmoke;">Start Date Time</th>
                                        <th style="text-align: center;color: whitesmoke;">End Date Time</th>
                                        <th style="text-align: center;color: whitesmoke;">Destination Device Name</th>
                                        <th style="text-align: center;color: whitesmoke;">EId</th>
                                        <!--<th style="text-align: center;">Career Level</th>-->
                                        <th style="text-align: center;color: whitesmoke;">Call Status</th>
                                        <th style="text-align: center;color: whitesmoke;">WBS</th>
                                        <th style="text-align: center;color: whitesmoke;">Approver EId</th>
                                        <th style="text-align: center;color: whitesmoke;">Approval Status</th>
                                        <th style="text-align: center;color: whitesmoke;">Approval Date</th>
                                        <th style="text-align: center;color: whitesmoke;">Remarks</th>
                                        <!--<th style="text-align: center;">CDuration</th>-->
                                        <!--<th style="text-align: center;">Active</th>-->
                                    </tr>
                                </thead>   
                                    <tbody *ngFor="let data of successfulData.GenereateReportDetails">
                                        <tr>
                                            <!--<td>{{data.cdrId}}</td>-->
                                            <td>
                                                {{data.callingPartyNumber}}
                                            </td>
                                            <td>
                                                {{data.originalCalledPartyNumber}}
                                            </td>
                                            <!--<td>
                                                {{data.dateTimeDisconnect}}
                                            </td>-->
                                            <td>
                                                {{data.cduration}}
                                            </td>
                                            <td>
                                                {{data.authCodeDescription}}
                                            </td>
                                            <td>
                                                {{data.startDateTime}}
                                            </td>
                                            <td>
                                                {{data.endDateTime}}
                                            </td>
                                            <td>
                                                {{data.destDeviceName}}
                                            </td>
                                            <td>
                                                {{data.eId}}
                                            </td>
                                            <!--<td>
                                                {{data.careerLevel}}
                                            </td>-->
                                            <td>
                                                {{data.callStatus}}
                                            </td>
                                            <td>
                                                {{data.wbs}}
                                            </td>
                                            <td>
                                                {{data.approverEid}}
                                            </td>
                                            <td>
                                                {{data.approvalStatus}}
                                            </td>
                                            <td>
                                                {{data.approvalDate}}
                                            </td>
                                            <td>
                                                {{data.remarks}}
                                            </td>
                                            <!--<td>{{data.Active}}</td>-->
                                        </tr>

                                    </tbody>
                                 <tfoot>
                                     <tr>
                                    <td colspan="11" style="text-align: center;">
                                        <!-- pager -->
                                        <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                            <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                <a><i (click)="setpagereport" class="icon-fast-backward"></i>
                                                </a>
                                            </li>
                                            <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                <a><i (click)="setpagereport(pager.currentPage - 1)" class="icon-step-backward"></i></a>
                                            </li>
                                            <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                                <a (click)="setpagereport(page)">{{page}}</a>
                                            </li>
                                            <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                                <a (click)="setpagereport(pager.startPage + 5)">...</a>
                                            </li>
                                            <li *ngIf="(pager.totalPages - pager.startPage) > 5" >
                                                <a (click)="setpagereport(pager.totalPages)">{{pager.totalPages}}</a>
                                            </li>
                                            
                                            <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                <a><i (click)="setpagereport(pager.currentPage + 1)" class="icon-step-forward"></i></a>
                                            </li>
                                            <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                <a><i (click)="setpagereport(pager.totalPages)" class="icon-fast-forward"></i></a>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                                 </tfoot>
                                </table> 
                                <br />
                        <div align="center">
                            <button type="submit" id="btnPreviewReport" class="btn btn-default btn-group-sm Button1" (click)="PreviewData('GenerateReportDetails')"><span class="" aria-hidden="true"></span>Export to Excel</button>
                        </div>   
                            </div>
                        </div>
                        
                    </div>
                </div>

                <div class="form-group" *ngIf="IsTabActive(5)">
                    <div class="row" id="divWBSEDetails">
                        <div style="margin-left: 20px; margin-right: 20px;">
                            <table id="WBSEDetail" class="table table-bordered" border="1" style="margin-left:2.7%;width:60%;font-size:13px;">
                                <thead style="background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                                    <tr>
                                        <th style="display:none">S.No</th>
                                        <th></th>
                                        <th style="text-align: center;color:whitesmoke;">Project Information</th>
                                        <th style="text-align: center;width:25%;color:whitesmoke;">Facility</th>
                                        <th style="text-align: center;color:whitesmoke;">WBSE</th>

                                    </tr>
                                </thead>
                                <tbody *ngFor="let WBSE of successfulData.WBSEData">
                                    <tr *ngIf="WBSE.Id != successfulData.selected.Id">
                                        <td>
                                            <img src="../../../../assets/img/Delete.png" title="Delete" (click)="DeleteWBSE(WBSE.Id)" />
                                        </td>
                                        <td style="display:none;">{{WBSE.Id}}</td>
                                        <td>{{WBSE.ProjectDescription}}</td>
                                        <td>{{WBSE.facility}}</td>
                                        <td>{{WBSE.ChargeCode}}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td>
                                            <button id="btnAddWBSE" type="button" class="btn btn-default btn-group-sm Button2" (click)="AddWBSE()">
                                                <span class="fa fa-check-circle" aria-hidden="true">
                                                </span> Add
                                            </button>
                                        </td>
                                        <td>
                                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                <span>*</span>
                                            </div>
                                            <input type="text" class="form-control" [(ngModel)]="WBSEDetails.ProjectDescription" placeholder=" Enter Project Information" id="grdfProjectDescription" name="grdfProjectDescription" required />
                                        </td>
                                        <td>
                                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                <span>*</span>
                                            </div>
                                            <!--<input type="text" class="form-control" ng-model="WBSEDetails.facility" id="grdfFacility" name="grdfFacility" required />-->
                                            <select [(ngModel)]="WBSEDetails.Facility" id="grdfFacility" name="grdfFacility" class="form-control" aria-label="grdfFacility" required>
                                                 <option value="">&lt;--Select--&gt;</option> 
                                                <!--<option value="">&lt; Select Facility &gt;</option>-->
                                                <option *ngFor="let f of Facilities">{{f.Description}}</option>
                                            </select>
                                        </td>
                                        <td>
                                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                <span>*</span>
                                            </div>
                                            <input type="text" class="form-control" [(ngModel)]="WBSEDetails.ChargeCode" placeholder=" Enter WBSE" id="grdfWBSE" name="grdfWBSE" required />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="11" style="text-align: center;">
                                            <!-- pager -->
                                            <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                                <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                    <a><i (click)="setPageWBS(1)" class="icon-fast-backward"></i>
                                                    </a>
                                                </li>
                                                <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                    <a><i (click)="setPageWBS(pager.currentPage - 1)" class="icon-step-backward"></i></a>
                                                </li>
                                                <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                                    <a (click)="setPageWBS(page)">{{page}}</a>
                                                </li>
                                                <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                                    <a (click)="setPageWBS(pager.startPage + 5)">...</a>
                                                </li>
                                                <li *ngIf="(pager.totalPages - pager.startPage) > 5" >
                                                    <a (click)="setPageWBS(pager.totalPages)">{{pager.totalPages}}</a>
                                                </li>
                                                
                                                <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                    <a><i (click)="setPageWBS(pager.currentPage + 1)" class="icon-step-forward"></i></a>
                                                </li>
                                                <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                    <a><i (click)="setPageWBS(pager.totalPages)" class="icon-fast-forward"></i></a>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>    
                        </div>    
                    </div>
                </div>
                <div class="form-group" *ngIf="IsTabActive(6)">
                    <!-- <div class="row" id="divMyAuthCode" *ngIf="_Country=='Philippines'"> -->
                    <div class="row" id="divMyAuthCode" >
                        <div style="margin-left: 20px; margin-right: 20px;">
                            <table id="MyAuthcode" class="table table-bordered" border="1" style="width:100%;font-size:13px;">
                                <thead style="background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                                    <tr>
                                        <th style="display:none">S.No</th>
                                        <!-- <th></th> -->
                                        <!-- <th style="text-align: center;color:whitesmoke;">Request Number</th> -->
                                        <th style="text-align: center;color:whitesmoke;">User ID</th>
                                        <th style="text-align: center;color:whitesmoke;">Supervisor</th>
                                        <th style="text-align: center;color:whitesmoke;">Location</th>
                                        <th style="text-align: center;color:whitesmoke;">Country</th>
                                        <th style="text-align: center;color:whitesmoke;">Authcode</th>
                                        <th style="text-align: center;color:whitesmoke;">From Date</th>
                                        <th style="text-align: center;color:whitesmoke;">To Date</th>
                                        <th style="text-align: center;color:whitesmoke;">WBSE</th>
                                        <th style="text-align: center;color:whitesmoke;">Business Reason</th>
                                    </tr>
                                </thead>
                                <tbody *ngFor="let MyAuthCode of successfulData.MyAuthCodeData">
                                    <tr *ngIf="MyAuthCode.Id != successfulData.selected.Id">
                                        <td style="display:none;">{{MyAuthCode.Id}}</td>
                                        <!-- <td>
                                            <img src="../../../../assets/img/Edit-icon.png" title="Edit" (click)="EditMyAuthCode(MyAuthCode)" />
                                        </td> -->
                                        <!-- <td>{{MyAuthCode.RITMNumber}}</td> -->
                                        <td>{{MyAuthCode.eId}}</td>
                                        <td>{{MyAuthCode.managerEid}}</td>
                                        <td>{{MyAuthCode.Facility}}</td>
                                        <td>{{MyAuthCode.Country}}</td>
                                        <td>{{MyAuthCode.authCodeId}}</td>
                                        <td>{{MyAuthCode.FromDate | date: 'yyyy-MM-dd'}}</td>
                                        <td>{{MyAuthCode.ToDate | date: 'yyyy-MM-dd'}}</td>
                                        <td>{{MyAuthCode.wbsElement}}</td>
                                        <td><textarea class="form-control" id="authCodeDescription" name="authCodeDescription" [(ngModel)]="MyAuthCode.authCodeDescription" maxlength="250" readonly="readonly" ></textarea></td>
                                    </tr>
                                    <tr *ngIf="MyAuthCode.Id === successfulData.selected.Id">
                                        <!-- <td style="width:75px;">
                                            <img src="../../../../assets/img/Add.png" (click)="UpdateMyAuthCode(MyAuthCode)" title="Update" />
                                            <img src="../../../../assets/img/Cancel.jpg" (click)="reset()" title="Cancel" />
                                        </td> -->
                                        <td style="display:none;">{{successfulData.selected.Id}}</td>
                                        <td>
                                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                <span></span>
                                            </div>
                                            <input  type="text" class="form-control" maxlength="25" [(ngModel)]="successfulData.selected.RITMNumber" readonly="readonly" [disabled]="true" id="grdRITMNumber" name="grdRITMNumber" />
                                        </td>
                                        <td>
                                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                <span></span>
                                            </div>
                                            <input type="text" class="form-control" maxlength="25" [(ngModel)]="successfulData.selected.eId" readonly="readonly" [disabled]="true" id="grdUserId" name="grdUserId" />
                                        </td>
                                        <td>
                                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                <span>*</span>
                                            </div>
                                            <input type="text" class="form-control" maxlength="25" [(ngModel)]="successfulData.selected.managerEid" id="grdmanagerEid" name="grdmanagerEid" required />
                                        </td>
                                        <td>
                                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                <span></span>
                                            </div>
                                            <input type="text" class="form-control" maxlength="25" [(ngModel)]="successfulData.selected.Facility" readonly="readonly" [disabled]="true" id="grdFacility" name="grdFacility" />
                                        </td>
                                        <td>
                                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                <span></span>
                                            </div>
                                            <input type="text" class="form-control" maxlength="25" [(ngModel)]="successfulData.selected.Country" readonly="readonly" [disabled]="true" id="grdCountry" name="grdCountry" />
                                        </td>
                                        <td>
                                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                <span></span>
                                            </div>
                                            <input type="text" class="form-control" maxlength="25" [(ngModel)]="successfulData.selected.authCodeId" readonly="readonly" [disabled]="true" id="grdauthCodeId" name="grdauthCodeId" />
                                        </td>
                                        <td>
                                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                <span></span>
                                            </div>
                                            <input type="text" class="form-control" maxlength="25" [(ngModel)]="successfulData.selected.FromDate" readonly="readonly" [disabled]="true" id="grdFromDate" name="grdFromDate" />
                                        </td>
                                        <td>
                                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                <span></span>
                                            </div>
                                            <input type="text" class="form-control" maxlength="25" [(ngModel)]="successfulData.selected.ToDate" readonly="readonly" [disabled]="true" id="grdToDate" name="grdToDate" />
                                        </td>
                                        <td>
                                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                <span>*</span>
                                            </div>
                                            <input type="text" class="form-control" maxlength="50" [(ngModel)]="successfulData.selected.wbsElement" id="grdwbsElement"  name="grdwbsElement" required />
                                        </td>
                                        <td>
                                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                <span></span>
                                            </div>
                                            <!--<input type="text" class="form-control" maxlength="250" ng-model="successfulData.selected.authCodeDescription" id="grdauthCodeDescription" ng-disabled="true" readonly="readonly" name="grdauthCodeDescription" />-->
                                            <textarea class="form-control" [(ngModel)]="successfulData.selected.authCodeDescription" maxlength="250" readonly="readonly" id="grdauthCodeDescription" [disabled]="true" name="grdauthCodeDescription" ></textarea>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="12" style="text-align:center">
                                                <div id="AlertForAccess"   *ngIf="SrcAlertForAccess" >
                                                <h4 style="color:red;"> No Records Found ! </h4>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="11" style="text-align: center;">                                          
                                            <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                                <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                    <a><i (click)="setPageauth(1)" class="icon-fast-backward"></i>
                                                    </a>
                                                </li>
                                                <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                    <a><i (click)="setPageauth(pager.currentPage - 1)" class="icon-step-backward"></i></a>
                                                </li>
                                                <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                                    <a (click)="setPageauth(page)">{{page}}</a>
                                                </li>
                                                <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                                    <a (click)="setPageauth(pager.startPage + 5)">...</a>
                                                </li>
                                                <li *ngIf="(pager.totalPages - pager.startPage) > 5" >
                                                    <a (click)="setPageauth(pager.totalPages)">{{pager.totalPages}}</a>
                                                </li>                                                
                                                <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                    <a><i (click)="setPageauth(pager.currentPage + 1)" class="icon-step-forward"></i></a>
                                                </li>
                                                <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                    <a><i (click)="setPageauth(pager.totalPages)" class="icon-fast-forward"></i></a>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>    
                    </div>
                    <!-- <div class="row" id="divMyAuthCodenew" *ngIf="_Country!='Philippines'">
                        <tr>
                            <td colspan="12" style="text-align:center">
                                <div id="divAlert" style="text-align: center;">
                                    <h4 style="color:red;text-align: center;"> *** Applicable only for Philippines users *** </h4>
                                </div>
                            </td>
                        </tr>
                    </div> -->
                </div>
                <div class="form-group" *ngIf="IsTabActive(7)">
                    <div class="row" id="divAuthCodeUpdateWBSE" >
                        <div style="margin-left: 20px; margin-right: 20px;">
                            <table id="MyAuthcode" class="table table-bordered" border="1" style="width:100%;font-size:13px;">
                                <thead style="background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                                    <tr>
                                        <th style="display:none">S.No</th>
                                        <th style="width:8%;"></th>
                                        <th style="text-align: center;color:whitesmoke;">Enterprise ID</th>
                                        <th style="text-align: center;color:whitesmoke;">Facility</th>
                                        <th style="text-align: center;color:whitesmoke;">Supervisor</th>
                                        <th style="text-align: center;color:whitesmoke;">Existing WBSE</th>
                                        <th style="display:none;text-align: center;color:whitesmoke;" id="thnewwbs">New WBSE</th>
                                    </tr>
                                </thead>
                                <tbody *ngFor="let MyAuthCode of successfulData.MyAuthCodeData">
                                    <tr *ngIf="MyAuthCode.Id != successfulData.selected.Id">
                                        <td style="display:none;">{{MyAuthCode.Id}}</td>
                                        <td>
                                            <img src="assets/img/Edit-icon.png" title="Edit" (click)="EditAuthCodeUpdateWBSE(MyAuthCode)" />
                                        </td>
                                        <td>{{MyAuthCode.eId}}</td>
                                        <td>{{MyAuthCode.Facility}}</td>
                                        <td>{{MyAuthCode.managerEid}}</td>
                                        <td>{{MyAuthCode.wbsElement}}</td>
                                    </tr>
                                    <tr *ngIf="MyAuthCode.Id === successfulData.selected.Id">
                                        <td style="width:75px;">
                                            <img src="assets/img/Add.png" (click)="UpdateAuthCodeUpdateWBSE(MyAuthCode)" title="Update" />
                                            <img src="assets/img/Cancel.jpg" (click)="reset()" title="Cancel" />
                                        </td>
                                        <td style="display:none;">{{successfulData.selected.Id}}</td>
                                        <td>
                                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                <span></span>
                                            </div>
                                            <input type="text" class="form-control" [(ngModel)]="successfulData.selected.eId" readonly="readonly" [disabled]="true" id="grdUserId" name="grdUserId" />
                                        </td>
                                        <td>
                                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                <span></span>
                                            </div>
                                            <input type="text" class="form-control" [(ngModel)]="successfulData.selected.Facility" readonly="readonly" [disabled]="true" id="grdFacility" name="grdFacility" />
                                        </td>
                                        <td>
                                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                <span>*</span>
                                            </div>
                                            <input type="text" class="form-control" maxlength="25" [(ngModel)]="successfulData.selected.managerEid" id="grdmanagerEid" name="grdmanagerEid"/>
                                        </td>
                                        <td>
                                            <!-- <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                <span>*</span>
                                            </div> -->
                                            <input type="text" class="form-control" maxlength="10" readonly="readonly" [disabled]="true" [(ngModel)]="successfulData.selected.wbsElement" id="grdwbsElement"  name="grdwbsElement"/>
                                        </td>
                                        <td>
                                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                                <span>*</span>
                                            </div>
                                            <input type="text" class="form-control" maxlength="10" [(ngModel)]="successfulData.selected.NewWBSE" id="grdNewwbsElement"  name="grdNewwbsElement"/>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="12" style="text-align:center">
                                                <div id="AlertForAccess"   *ngIf="SrcAlertForAccess" >
                                                <h4 style="color:red;"> No Records Found ! </h4>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="11" style="text-align: center;">                                          
                                            <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                                <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                    <a><i (click)="setPageauth(1)" class="icon-fast-backward"></i>
                                                    </a>
                                                </li>
                                                <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                    <a><i (click)="setPageauth(pager.currentPage - 1)" class="icon-step-backward"></i></a>
                                                </li>
                                                <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                                    <a (click)="setPageauth(page)">{{page}}</a>
                                                </li>
                                                <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                                    <a (click)="setPageauth(pager.startPage + 5)">...</a>
                                                </li>
                                                <li *ngIf="(pager.totalPages - pager.startPage) > 5" >
                                                    <a (click)="setPageauth(pager.totalPages)">{{pager.totalPages}}</a>
                                                </li>                                                
                                                <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                    <a><i (click)="setPageauth(pager.currentPage + 1)" class="icon-step-forward"></i></a>
                                                </li>
                                                <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                    <a><i (click)="setPageauth(pager.totalPages)" class="icon-fast-forward"></i></a>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>    
                    </div>
                </div>

                <div class="overlay" [ngStyle]="{'display':displayPopUp}">
                    <div class="modal" tabindex="-1" role="dialog" style="padding-left: 17px;">
                        <div class="modal-header">
                            <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
                                    aria-hidden="true">&times;</span></button>
                            <h4 class="modal-title">MarkCall Details</h4>
                        </div>
                        <div class="modal-body" style="height: 160vh;">
                            <div class="form-group row">
                                <div class="col-sm-3 col-md-offset-1" style="padding-top: 1%; margin-top: -10px;">
                                    <span class="tooltip" style=" position: relative;z-index: 0; ">
                                        <img alt="" src="../../../../assets/img/info10.png" class="img-circle" style="width: 12%; height: 10%; margin-bottom: -30%; margin-left: 90%;">
                                        <span class="tooltiptext" style="margin-bottom: -16px; margin-left: -75%;">The purpose of call made by caller.</span>
                                    </span>
                                    <label for="Mark As">Mark As:</label>
                                </div>
                                <div class="col-sm-4">
                                    <select class="form-control" id="MarkAs" name="MarkAs"
                                    [(ngModel)]="successfulData.selected.callStatus" (change)="MarkAction(successfulData.selected.callStatus)">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let M of MarkList" value="{{M.Value}}">{{M.Value}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group row" id="divWBSElement" [hidden]="!showWBSElement">
                                <div class="col-sm-3 col-md-offset-1" style="margin-top: -15px; ">
                                    <span class="tooltip" style=" position: relative;z-index: 0;">
                                        <img alt="" src="assets/img/info10.png" class="img-circle" style="width: 12%; height: 10%; margin-bottom: -30%; margin-left: 90%;">
                                        <span class="tooltiptext" style="margin-bottom: -16px; margin-left: -75%;">Cost collector to charge the call.</span>
                                    </span>
                                    <label for="WBS Element">WBS Element:</label>    
                                </div>
                                <div class="col-sm-4">
                                    <input type="text" id="Type" name="Type" [(ngModel)]="successfulData.selected.Type" style="display:none;" />
                                    <input type="text" id="cdrId" name="cdrId"  [(ngModel)]="successfulData.selected.cdrId" style="display:none;" />
                                    <input type="text" id="WBSElement" name="WBSElement"  [(ngModel)]="successfulData.selected.wbs" />
                                </div>
                            </div>

                            <div class="form-group row" id="divApprover" [hidden]="!showApprover">
                                <div class="col-sm-3 col-md-offset-1" style="padding-top: 1%; margin-top: -20px; ">
                                    <span class="tooltip" style=" position: relative;z-index: 0; ">
                                        <img alt="" src="assets/img/info10.png" class="img-circle" style="width: 12%; height: 10%; margin-bottom: -30%; margin-left: 90%;">
                                        <span class="tooltiptext" style="margin-bottom: -16px; margin-left: -75%;">Enter appropiate approver for the User.</span>
                                    </span> 
                                    <label for="Approver">Approver:</label> 
                                </div>
                                <div class="col-sm-4">
                                    <input type="text" id="Approver" name="Approver"
                                        [(ngModel)]="successfulData.selected.approverEid" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-sm-3 col-md-offset-1" style="padding-top: 1%; margin-top: -15px;">
                                    <span class="tooltip" style=" position: relative;z-index: 0; ">  
                                        <img alt="" src="assets/img/info10.png" class="img-circle" style="width: 12%; height: 10%; margin-bottom: -30%; margin-left: 90%;">
                                        <span class="tooltiptext" style="margin-bottom: -16px; margin-left: -75%;">Reason why the call is marked as selected call type.</span>
                                    </span> 
                                    <label for="Remarks">Remarks:</label>  
                                </div>
                                <div class="col-sm-4">
                                    <textarea id="Remarks" name="Remarks" [(ngModel)]="successfulData.selected.remarks"
                                        style="width:162px;" maxlength="1000"></textarea>
                                </div>
                            </div>
                            <div align="center">
                                <button type="submit" id="btnsave" class="btn btn-default btn-group-sm Button1"
                                    (click)="MarkCallsAdd()"><span class=""
                                        aria-hidden="true"></span>Save</button>&nbsp;
                                <button type="submit" id="btnClose" class="btn btn-default btn-group-sm Button1"
                                    (click)="closeModal()"><span class="fa fa-close"
                                        aria-hidden="true"></span>Cancel</button>
                            </div>

                        </div>
                    </div>
                </div> 

                <!-- ****************showModalWBS************* -->
                <div class="overlay" [ngStyle]="{'display':displayWBS}">
                    <div class="modal" tabindex="-1" role="dialog" style="padding-left: 17px;">
                        <div class="modal-header">
                            <button type="button" class="close" aria-label="Close" (click)="closeWBSModal()"><span
                                aria-hidden="true">&times;</span></button>
                             <h4 class="modal-title">Enter Valid WBS</h4>
                        </div>
                        <div class="modal-body" style="height: 160vh;">
                            <div class="form-group row">
                                <div class="col-md-2 col-md-offset-1" style="padding-top:1%">
                                    <label for="WBS">WBS</label>
                                </div>
                                <div class="col-md-4">
                                    <input type="text" class="form-control" id="txtProfileWBS" name="txtProfileWBS" [(ngModel)]="txtProfileWBS" />
                                </div>
                            </div>
                            <div class="row col-md-offset-3" align="center">
                                <div class="col-sm-2"><button type="submit" id="btnsave1" class="btn btn-default btn-group-sm Button1" (click)="SaveWBS()"><span class="" aria-hidden="true"></span>Save</button></div>
                                <div class="col-sm-2"><button type="submit" id="btnWBS" class="btn btn-default btn-group-sm Button1" (click)="Cancel('WBS')"><span class="" aria-hidden="true"></span>Cancel</button></div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- **************showModalWBSMark***************** -->
                <div class="overlay" [ngStyle]="{'display':displayWBSMark}">
                    <div class="modal" tabindex="-1" role="dialog" style="padding-left: 17px;">
                        <div class="modal-header">
                            <button type="button" class="close" aria-label="Close" (click)="closeWBSMark()"><span
                                    aria-hidden="true">&times;</span></button>
                            <h4 class="modal-title">Click on Appropriate WBS Codes</h4>
                        </div>
                        <div class="modal-body" style="height: 160vh;">
                            <table id="WBSEMarkDetail" class="table table-bordered" border="1"
                                style="margin-left:2.7%;width:60%;font-size:13px;overflow:free;">
                                <thead
                                    style="background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                                    <tr>
                                        <th style="display:none">S.No</th>
                                        <th style="text-align: center;width:25%;color:whitesmoke;">Project Description</th>
                                        <th style="text-align: center;color:whitesmoke;">WBSE</th>
                
                                    </tr>
                                </thead>
                                <tbody *ngFor="let AssignBSEData of AssignBSEDatas">
                                    <tr>
                                        <td style="display:none;">{{AssignBSEData.sno}}</td>
                
                                        <td>{{AssignBSEData.ProjectDescription}}</td>
                                        <!--<td>{{AssignBSEData.wbsElement}}</td-->
                                        <th>
                                            <button type="submit" id="btnAssignWBS" class="btn btn-default btn-group-sm Button1"
                                                (click)="SubmitWBSData(AssignBSEData)">
                                                {{AssignBSEData.ChargeCode}}
                                            </button>
                                        </th>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="11" style="text-align: center;">
                                            <!-- pager -->
                                            <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                                <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                    <a><i (click)="setPages(1)" class="icon-fast-backward"></i>
                                                    </a>
                                                </li>
                                                <li [ngClass]="{disabled:pager.currentPage === 1}">
                                                    <a><i (click)="setPages(pager.currentPage - 1)" class="icon-step-backward"></i></a>
                                                </li>
                                                <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                                    <a (click)="setPages(page)">{{page}}</a>
                                                </li>
                                                <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                                    <a (click)="setPages(pager.startPage + 5)">...</a>
                                                </li>
                                                <li *ngIf="(pager.totalPages - pager.startPage) > 5" >
                                                    <a (click)="setPages(pager.totalPages)">{{pager.totalPages}}</a>
                                                </li>
                                                
                                                <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                    <a><i (click)="setPages(pager.currentPage + 1)" class="icon-step-forward"></i></a>
                                                </li>
                                                <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                                    <a><i (click)="setPages(pager.totalPages)" class="icon-fast-forward"></i></a>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tfoot>

                            </table>
                            <div align="center" class="row col-md-offset-4">
                
                                <div class="col-sm-1" id="btnWBSCancel"><button class="btn btn-default btn-group-sm Button1"
                                        style="display: block;" type="submit" (click)="Cancel('WBSCalls')"><span
                                            aria-hidden="true"></span>Cancel</button></div>
                
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ******************showModalApproveCalls***************** -->
                <div class="overlay" [ngStyle]="{'display':displayApproveCalls}">
                    <div class="modal" tabindex="-1" role="dialog" style="padding-left: 17px;">
                        <div class="modal-header">
                            <button type="button" class="close" aria-label="Close" (click)="closeApproveCalls()"><span
                                aria-hidden="true">&times;</span></button>
                            <h4 class="modal-title">Approve Call Details</h4>
                        </div>
                        <div class="modal-body" style="height: 160vh;">
                            <div class="form-group row">
                                <div class="col-sm-2 col-md-offset-1" style="padding-top:1%">
                                    <label for="Mark As">Action:</label>
                                </div>
                                <div class="col-sm-4">
                                        <select class="form-control" id="ActionAs" name="ActionAs" [(ngModel)]="successfulData.selected.approvalStatus" (change)="Action($event.target.value)">
                                        <option value="">&lt;--Select--&gt;</option>
                                        <option *ngFor="let A of ApproverList" value="{{A.Value}}">{{A.Value}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row" id="divApproverName">
                                <div class="col-sm-2 col-md-offset-1" style="padding-top:1%">
                                    <label for="Approver">Approver:</label>
                                </div>
                                <div class="col-sm-4">
                                    <input type="text" id="AcdrId" name="AcdrId"  [(ngModel)]="successfulData.selected.cdrId" style="display:none;" />

                                    <input type="text" id="AType" name="AType"  [(ngModel)]="successfulData.selected.AType" style="display:none;" />
                                    <input type="text" id="ApproverName" name="ApproverName"  [(ngModel)]="successfulData.selected.approverEid" />    
                                </div>
                            </div>
                            <div class="form-group row" id="divWBS">
                                <div class="col-sm-2 col-md-offset-1" style="padding-top:1%">
                                    <label for="WBS Element">WBS Element:</label>
                                </div>
                                <div class="col-sm-4">
                                    <input type="text" id="Wbs" name="Wbs" [(ngModel)]="successfulData.selected.wbs" />
                               </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-sm-2 col-md-offset-1" style="padding-top:1%">
                                    <label for="Remarks">Remarks:</label>
                                </div>
                                <div class="col-sm-4">
                                    <textarea id="ARemarks" name="ARemarks" [(ngModel)]="successfulData.selected.remarks" style="width:162px;"></textarea>
                               </div>
                            </div>
                            <div align="center" class="row col-md-offset-4">
                                <div class="col-sm-2"><button class="btn btn-default btn-group-sm Button1" id="btnsave2" type="submit" (click)="ApproveCallsAdd()"><span aria-hidden="true"></span>Save</button></div>
                                <div class="col-sm-1" id="btnApprovecancel"><button class="btn btn-default btn-group-sm Button1" style="display: block;" type="submit" (click)="Cancel('ApproveCalls')"><span aria-hidden="true"></span>Cancel</button></div>
                                <!-- <div class="col-sm-1" id="btnEditApprovecancel"><button class="btn btn-default btn-group-sm Button1" style="display: block;" type="submit" (click)="Cancel('MyApproveCalls')"><span aria-hidden="true"></span>Cancel</button></div> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="overlay" [ngStyle]="{'display':displayApprovedCalls}">
                    <div class="modal" tabindex="-1" role="dialog" style="padding-left: 17px;">
                        <div class="modal-header">
                            <button type="button" class="close" aria-label="Close" (click)="closeApprovedCalls()"><span
                                aria-hidden="true">&times;</span></button>
                            <h4 class="modal-title">Approved Call Details</h4>
                        </div>
                        <div class="modal-body" style="height: 160vh;">
                            <div class="form-group row">
                                <div class="col-sm-2 col-md-offset-1" style="padding-top:1%">
                                    <label for="Mark As">Action:</label>
                                </div>
                                <div class="col-sm-4">
                                        <select class="form-control" id="ActionAs1" name="ActionAs1" [(ngModel)]="successfulData.selected.approvalStatus" (change)="ActionApprove($event.target.value)">
                                        <option value="">&lt;--Select--&gt;</option>
                                        <option value="Approve">Approve</option>
                                        <option value="Change WBS">Change WBS</option>
                                    </select>
                                </div>
                            </div>
                            <!-- <div class="form-group row" id="divApproverName">
                                <div class="col-sm-2 col-md-offset-1" style="padding-top:1%">
                                    <label for="Approver">Approver:</label>
                                </div>
                                <div class="col-sm-4">
                                    <input type="text" id="AcdrId" name="AcdrId"  [(ngModel)]="successfulData.selected.cdrId" style="display:none;" />

                                    <input type="text" id="AType" name="AType"  [(ngModel)]="successfulData.selected.AType" style="display:none;" />
                                    <input type="text" id="ApproverName" name="ApproverName"  [(ngModel)]="successfulData.selected.approverEid" />    
                                </div>
                            </div> -->
                            <div class="form-group row" id="divappWBS">
                                <div class="col-sm-2 col-md-offset-1" style="padding-top:1%">
                                    <label for="WBS Element">WBS Element:</label>
                                </div>
                                <div class="col-sm-4">
                                    <input type="text" id="Wbs1" name="Wbs1" [(ngModel)]="successfulData.selected.wbs" />
                               </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-sm-2 col-md-offset-1" style="padding-top:1%">
                                    <label for="Remarks">Remarks:</label>
                                </div>
                                <div class="col-sm-4">
                                    <textarea id="ARemarks1" name="ARemarks1" [(ngModel)]="successfulData.selected.remarks" style="width:162px;"></textarea>
                               </div>
                            </div>
                            <div align="center" class="row col-md-offset-4">
                                <div class="col-sm-2"><button class="btn btn-default btn-group-sm Button1" id="btnsave3" type="submit" (click)="ApproveCallsAdd()"><span aria-hidden="true"></span>Save</button></div>
                                <!-- <div class="col-sm-1" id="btnApprovecancel"><button class="btn btn-default btn-group-sm Button1" style="display: block;" type="submit" (click)="Cancel('ApproveCalls')"><span aria-hidden="true"></span>Cancel</button></div> -->
                                <div [ngStyle]="{'display':btnEditApprovecancel}" class="col-sm-1" id="btnEditApprovecancel"><button class="btn btn-default btn-group-sm Button1" style="display: block;" type="submit" (click)="Cancel('MyApproveCalls')"><span aria-hidden="true"></span>Cancel</button></div>
                            </div>
                        </div>
                    </div>
                </div>


                <div id="AlertPeriodExpired" style="display:none;">
                    <div class="row" style="padding-top:10%">
                        <div class="col-sm-8 col-md-offset-1" style="margin-top:-5%">
                            <h4>
                                The period for marking of calls may have not yet started or have already expired.
                                Please contact respective Regional Voice Team.
                            </h4>
                        </div>
                    </div>
                </div>

                <div id="AlertForBusinessOnly" style="display:none;">
                    <div class="row" style="padding-top:10%">
                        <div class="col-sm-6 col-md-offset-1" style="margin-top:-5%">
                            <h4>
                                This page is only available for some selected countries.
                                <br />
                                Please contact respective Regional Voice Team.
                            </h4>
                        </div>

                    </div>

                </div>
                
                <!-- <modal title="MarkCall Details" visible="showModalMarkCalls" id="divMark">
                    <div class="form-group row">
                        <div class="col-sm-3 col-md-offset-1" style="padding-top: 1%; margin-top: -10px;">
                            <span class="tooltip" style=" position: relative; ">
                                <img alt="" src="img/info10.png" class="img-circle" style="width: 12%; height: 10%; margin-bottom: -30%; margin-left: 79%;">
                                <span class="tooltiptext" style="margin-bottom: -16px; margin-left: -75%;">The purpose of call made by caller.</span>    
                            </span><label for="Mark As">Mark As:</label>
                        </div>

                        <div class="col-sm-4">
                            <select class="form-control" id="MarkAs" name="MarkAs" [(ngModel)]="successfulData.selected.callStatus" (change)="MarkAction()">
                                <option value="">&lt;--Select--&gt;</option>
                                <option *ngFor="let M of MarkList" value="{{M.Value}}">{{M.Value}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row" id="divWBSElement">
                        <div class="col-sm-3 col-md-offset-1" style="margin-top: -15px; ">
                            <span class="tooltip" style=" position: relative; ">
                                <img alt="" src="img/info10.png" class="img-circle" style="width: 12%; height: 10%; margin-bottom: -30%; margin-left: 79%;">
                                <span class="tooltiptext" style="margin-bottom: -16px; margin-left: -75%;">Cost collector to charge the call.</span>
                            </span><label for="WBS Element">WBS Element:</label>

                        </div>
                        <div class="col-sm-4">
                            <input type="text" id="Type" name="Type" [(ngModel)]="successfulData.selected.Type" style="display:none;" />
                            <input type="text" id="cdrId" name="cdrId"  [(ngModel)]="successfulData.selected.cdrId" style="display:none;" />

                            <input type="text" id="WBSElement" name="WBSElement"  [(ngModel)]="successfulData.selected.wbs" />
                        </div>
                    </div>
                    <div class="form-group row" id="divApprover">
                        <div class="col-sm-3 col-md-offset-1" style="padding-top: 1%; margin-top: -20px; ">
                            <span class="tooltip" style=" position: relative; ">
                                <img alt="" src="img/info10.png" class="img-circle" style="width: 12%; height: 10%; margin-bottom: -30%; margin-left: 79%;">
                                <span class="tooltiptext" style="margin-bottom: -16px; margin-left: -75%;">Enter appropiate approver for the User.</span>
                            </span>    
                        </div>
                        <div class="col-sm-4">
                            <input type="text" id="Approver" name="Approver" [(ngModel)]="successfulData.selected.approverEid" />
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-3 col-md-offset-1" style="padding-top: 1%; margin-top: -15px;">
                            <span class="tooltip" style=" position: relative; ">  
                                <img alt="" src="img/info10.png" class="img-circle" style="width: 12%; height: 10%; margin-bottom: -30%; margin-left: 79%;">
                                <span class="tooltiptext" style="margin-bottom: -16px; margin-left: -75%;">Reason why the call is marked as selected call type.</span>
                            </span> <label for="Remarks">Remarks:</label>  
                        </div>
                        <div class="col-sm-4">
                            <textarea id="Remarks" name="Remarks" [(ngModel)]="successfulData.selected.remarks" style="width:162px;" ></textarea>


                        </div>
                    </div>    
                </modal> -->
                <!-- <modal title="Click on Appropriate WBS Codes" visible="showModalWBSMark" id="divWBSMark">
                    <table id="WBSEMarkDetail" class="table table-bordered" border="1" style="margin-left:2.7%;width:60%;font-size:13px;">
                        <thead style="background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                            <tr>
                                <th style="display:none">S.No</th>
                                <th style="text-align: center;width:25%;color:whitesmoke">Project Description</th>
                                <th style="text-align: center;color: whitesmoke;">WBSE</th>

                            </tr>
                        </thead>
                        <tr *ngFor="let AssignBSEData of AssignBSEDatas">
                            <td style="display:none;">{{AssignBSEData.sno}}</td>

                            <td>{{AssignBSEData.ProjectDescription}}</td> -->
                            <!--<td>{{AssignBSEData.wbsElement}}</td-->
                            <!-- <th>
                                <button type="submit" id="btnAssignWBS" class="btn btn-default btn-group-sm Button1" (click)="SubmitWBSData(AssignBSEData)">
                                    {{AssignBSEData.ChargeCode}}
                                </button>
                            </th>
                        </tr>
                    </table>
                    <div align="center" class="row col-md-offset-4">

                        <div class="col-sm-1" id="btnWBSCancel"><button class="btn btn-default btn-group-sm Button1" style="display: block;" type="submit" (click)="Cancel('WBSCalls')"><span aria-hidden="true"></span>Cancel</button></div>

                    </div>    
                </modal> -->
                <!-- <div style="display:none;">
                    <div class="col-sm-4">
                        <input type="text" id="eIds" name="eIds" [(ngModel)]="successfulData.selected.eId" />
                    </div>
                </div>
                <div id="AlertPeriodExpired" style="display:none;">
                    <div class="row" style="padding-top:10%">
                        <div class="col-sm-8 col-md-offset-1" style="margin-top:-5%">
                            <h4>
                                The period for marking of calls may have not yet started or have already expired.
                                Please contact respective Regional Voice Team.
                            </h4>
                        </div>

                    </div>

                </div>

                <div id="AlertForBusinessOnly" style="display:none;">
                    <div class="row" style="padding-top:10%">
                        <div class="col-sm-6 col-md-offset-1" style="margin-top:-5%">
                            <h4>
                                This page is only available for some selected countries.
                                <br />
                                Please contact respective Regional Voice Team.
                            </h4>
                        </div>

                    </div>

                </div> -->

            </div>    
        </div>    
    </div>
</form>
